import React from 'react';
import { Person } from 'talent_matching/types';
import { useRankingInProgress } from 'talent_matching/contexts/ranking_in_progress_context';
import BaseMatchStrengthCell from 'talent_matching/components/shared/base_match_strength_cell';

type Props = {
  candidate: Person;
  openCalibrationModal: () => void;
};

const MatchStrengthCell = ({ candidate, openCalibrationModal }: Props) => {
  const { hasCalibrationSetting } = useRankingInProgress();

  return (
    <BaseMatchStrengthCell
      matchStrength={candidate.matchStrength ?? null}
      matchScore={candidate.matchScore ?? null}
      matchedSkills={candidate.matchedSkills || []}
      numCalibrationSkills={candidate.numCalibrationSkills ?? 0}
      overrideMatchStrength={candidate.overrideMatchStrength}
      resumeParsingStatus={candidate.resume?.parsing_status}
      hasCalibrationSetting={hasCalibrationSetting}
      openCalibrationModal={openCalibrationModal}
    />
  );
};

export default MatchStrengthCell;
